import { Checkbox } from "@mantine/core";

import cx from "./mightier_checkbox.module.css";

export const MightierCheckbox = Checkbox.withProps({
  classNames: {
    inner: cx["checkbox-inner"],
    icon: cx["checkbox-icon"],
    input: cx["checkbox-input"],
    label: cx["checkbox-label"],
  },
});
